
import { defineComponent, PropType, computed } from "vue";
import SwipeablePosterCard from "@/components/SwipeablePosterCard.vue";
import { Show } from "@/types";

export default defineComponent({
  name: "MovieCardStack",
  components: {
    SwipeablePosterCard,
  },
  props: {
    shows: {
      type: Array as PropType<Show[]>,
      required: true,
    },
  },
  emits: ["add-show", "reject-show"],
  setup(props) {
    const lastShowIndex = computed(() => props.shows.length - 1);

    return { lastShowIndex };
  },
});
